<template>
    <div class="message-admin mt-page">

        <b-row>
            <b-col>
                <h1>
                    {{ $i18n.gt('HEADING_MANAGE_MESSAGES_FOR') }} {{ practiceName }}
                </h1>
            </b-col>
            <b-col class="text-right">
                <router-link class="btn btn-ghost-blue mr-3 mb-3"
                             :to="createRoute">
                    <shs-icon name="plus"></shs-icon>
                    {{ $i18n.gt('LABEL_NEW_MESSAGE') }}
                </router-link>
            </b-col>
        </b-row>

        <data-table ref="dataTable"
                    :show-filters="true"
                    :show-pager="true"
                    :show-details="false"
                    :get-items="getMessages"
                    :filters="filters"
                    :fields="fields">

            <!-- template for custom columns -->
            <template v-slot:customField="slotProps">
                <div v-if="slotProps.row.field.key == 'actions'">
                    <router-link class="btn btn-secondary btn-sm mr-2"
                                 :to="getUpdateRoute(slotProps.row.item)">
                        <shs-icon name="pencil"></shs-icon>
                    </router-link>
                    <b-btn size="sm"
                           variant="danger"
                           @click="deleteMessage(slotProps.row.item)">
                        <shs-icon name="delete"></shs-icon>
                    </b-btn>
                </div>
                <div v-else-if="slotProps.row.field.key == 'role'">
                    {{ slotProps.row.item.role }}
                    <b-badge variant="danger" class="ml-3"
                             v-if="slotProps.row.item.disabled">
                        {{ $i18n.gt('LABEL_DISABLED') }}
                    </b-badge>
                </div>
                <div v-else-if="slotProps.row.field.key == 'lastActiveTime'">
                    <timestamp :date="slotProps.row.item.participant.lastActiveTime"></timestamp>
                </div>
                <div v-else-if="slotProps.row.field.key == 'receive_appointment_alert'">
                    {{ slotProps.row.item.receive_appointment_alert ? 'Yes' : '' }}
                </div>
            </template>

        </data-table>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'

/**
 * Page for a Message to manage Messages for their Practice
 */
export default Vue.extend({
    name: 'MessageAdmin',
    data() {
        return {
            practiceName: '',
            filters: {
                practice_id: {field: 'practice_id', type: 'hidden', value: this.practiceId},
                name: {field: 'name', type: 'string', value: null, label: 'Template Name'},
                subject: {field: 'subject', type: 'string', value: null, label: 'Subject'},
            },
            fields: [
                {key: 'name', sortable: true, label: 'Template Name'},
                {key: 'subject', sortable: true, label: 'Subject'},
                {key: 'actions', sortable: false},
            ],
        }
    },
    computed: {
        practiceId() {
            return this.$user.practitionerPracticeId()
        },
        createRoute() {
            return `/message/create/practiceId/${this.practiceId}`
        },
    },
    methods: {
        getUpdateRoute(message) {
            return `/message/update/practiceId/${this.practiceId}/id/${message.id}`
        },
        getMessages(listParams) {
            return this.$api.getMessages(this, this.filters, listParams, this.practiceId)
        },
        async deleteMessage(message) {
            const msg = `Delete message ${message.name} permanently from the database?`
            if (await this.$bvModal.msgBoxConfirm(msg)) {
                try {
                    await this.$api.deleteItem(this, 'message', message)
                    this.$toasted.show('Message deleted', {duration: 3000})
                    this.$refs.dataTable.refresh();
                } catch (e) {
                    this.$utils.handleError(e, 'Error deleting message')
                }
            }
        },

    },
    async mounted() {
        // load practice
        const practice = await this.$api.getItem(this, 'practice', this.practiceId)
        this.practiceName = practice.name
    }
})

</script>
